var exports = {
  "default": "x31de4314--363dc0--default",
  "light": "x31de4314--363dc0--light",
  "outline": "x31de4314--363dc0--outline",
};

module.exports = exports;
